import { render, staticRenderFns } from "./EditDrawing.vue?vue&type=template&id=01c534e8&scoped=true&"
import script from "./EditDrawing.vue?vue&type=script&lang=js&"
export * from "./EditDrawing.vue?vue&type=script&lang=js&"
import style0 from "./EditDrawing.vue?vue&type=style&index=0&id=01c534e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c534e8",
  null
  
)

export default component.exports